module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fastest.9f9566c6.svg";